(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MeasurementUnitDialogController', MeasurementUnitDialogController);

    MeasurementUnitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MeasurementUnit'];

    function MeasurementUnitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MeasurementUnit) {
        var vm = this;
        vm.measurementUnit = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:measurementUnitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.measurementUnit.id !== null) {
                MeasurementUnit.update(vm.measurementUnit, onSaveSuccess, onSaveError);
            } else {
                MeasurementUnit.save(vm.measurementUnit, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
